function FindChild({ query, list, recursive = false, property }) {
    const children = [];
    for (const obj of list) {
        let found = true;
        for (const k in query) {
            if (Object.prototype.hasOwnProperty.call(query, k)) {
                if (property) {
                    if (obj[property][k] !== query[k]) {
                        found = false;
                        break;
                    }
                }
                else if (obj[k] !== query[k]) {
                    found = false;
                    break;
                }
            }
        }
        if (found)
            return obj;
        if (recursive)
            children.push(...obj.children);
    }
    if (recursive && children.length)
        return FindChild({ query, list: children, recursive, property });
}

export { FindChild };
//# sourceMappingURL=find-child.js.map
